import { useState } from "react"
import { Description } from "@mui/icons-material"
import { Badge, IconButton, Popover, Tooltip } from "@mui/material"
import { Grid, Typography } from "src/lib/components/basics"
import { SUPPORTED_ATTACHMENT_MIME_TYPES } from "src/services/api/chat/attachments"
import { useContextDocumentsStore } from "src/store/contextDocumentsStore"

const documentTypeLabel = (mimeType: string) => SUPPORTED_ATTACHMENT_MIME_TYPES[mimeType] ?? "Arquivo"

const ContextDocumentsButton = () => {
    const documents = useContextDocumentsStore((s: any) => s.documents)
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

    const sortedDocuments = [...documents].sort((a, b) => {
        const typeA = documentTypeLabel(a.mimeType)
        const typeB = documentTypeLabel(b.mimeType)
        return typeA !== typeB ? typeA.localeCompare(typeB) : a.filename.localeCompare(b.filename)
    })

    return (
        <>
            <IconButton
                onClick={(e) => setAnchorEl(e.currentTarget)}
                size="medium"
                sx={{
                    color: "neutral.lightest",
                    "&:hover": { backgroundColor: "transparent" },
                }}
            >
                <Badge
                    badgeContent={documents.length}
                    color="primary"
                    sx={{
                        "& .MuiBadge-badge": {
                            minWidth: 16,
                            height: 16,
                            fontSize: "0.625rem",
                            padding: 0,
                        },
                    }}
                >
                    <Description fontSize="medium" />
                </Badge>
            </IconButton>
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Grid container direction="column" gap={1} sx={{ p: 1.5, minWidth: 260, maxWidth: 340 }}>
                    <Typography color="tertiary" variant="body2" sx={{ fontWeight: 600 }}>
                        Documentos em contexto
                    </Typography>
                    {documents.length === 0 ? (
                        <Typography color="secondary" variant="caption">
                            Nenhum documento anexado nesta conversa ainda.
                        </Typography>
                    ) : (
                        sortedDocuments.map((document: any, index: number) => (
                            <Tooltip key={`${document.filename}-${index}`} title={document.filename}>
                                <Grid container alignItems="center" gap={1} wrap="nowrap">
                                    <Typography
                                        color="quaternary"
                                        variant="caption"
                                        sx={{ fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0 }}
                                    >
                                        {documentTypeLabel(document.mimeType)}
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {document.filename}
                                    </Typography>
                                </Grid>
                            </Tooltip>
                        ))
                    )}
                </Grid>
            </Popover>
        </>
    )
}

export { ContextDocumentsButton }
